import {OfferRuleModel} from './offer-rule.model';
import {
  BulkOfferRuleCreate,
  BulkOfferRuleData,
  BulkOfferRuleDelete,
  BulkOfferRuleUpdate
} from './bulk-offer-rule.model';

export const ruleChangeStates = {
  clean: 'clean',
  created: 'created',
  updated: 'updated',
  deleted: 'deleted'
} as const;

export type RuleChangeState = typeof ruleChangeStates[keyof typeof ruleChangeStates];

export interface EditableOfferRule {
  clientKey: string;
  rule: OfferRuleModel;
  changeState: RuleChangeState;
  vehicleCriteriaTags: string[];
}

export interface NormalizedWritableOfferRule extends BulkOfferRuleData {
  minSalePrice?: number | null;
}

export interface OfferRuleChangeSet {
  creates: BulkOfferRuleCreate[];
  updates: BulkOfferRuleUpdate[];
  deletes: BulkOfferRuleDelete[];
}

export interface OfferRuleChangeSetValidation {
  isValid: boolean;
  operationCount: number;
  errors: string[];
}
